import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { CloseIcon, ExpandRightIcon } from '@wf-sl/common-icons'

import PanelHeaderButton from './panel-header-button'

import styles from './panel.module.css'

const propTypes = {
    CloseComponent: PropTypes.node,
    ExpandComponent: PropTypes.node,
    // eslint-disable-next-line react/forbid-prop-types
    children: PropTypes.any,
    className: PropTypes.string,
    classNamePanelHeaderButtonClose: PropTypes.string,
    classNamePanelHeaderButtonExpand: PropTypes.string,
    isClosable: PropTypes.bool,
    isExpandable: PropTypes.bool,
    onClose: PropTypes.func,
    onExpand: PropTypes.func,
    style: PropTypes.object // eslint-disable-line react/forbid-prop-types
}

const defaultProps = {
    CloseComponent: <CloseIcon width={24} height={24} />,
    ExpandComponent: <ExpandRightIcon width={24} height={24} />,
    isClosable: true,
    isExpandable: false
}

/**
 * Render a {@link Panel} header component.
 *
 * @param {Object} [props] - The current component properties
 * @param {ReactElement|string|number} [props.children] - The children to be rendered
 * @param {string} [props.className] - Classname to be added
 * @param {string} [props.classNamePanelHeaderButtonClose] - Classname for the panel header close btn
 * @param {string} [props.classNamePanelHeaderButtonExpand] - Classname for the panel header expand btn
 * @param {ReactElement} [props.CloseComponent=<CloseIcon />] - A custom close component
 * @param {ReactElement} [props.ExpandComponent=<ExpandRightIcon />] - A custom expand button component
 * @param {boolean} [props.isClosable=true] - Add CloseIcon to header or not
 * @param {boolean} [props.isExpandable=false] - Show expand button or not
 * @param {Function} [props.onClose] - Callback when close button get's clicked
 * @param {Function} [props.onExpand] - Callback when expand button get's clicked
 * @param {Object} [props.style] - Addional style attribute contents
 * @returns {ReactElement}
 */
function PanelHeader(props) {
    const {
        CloseComponent,
        ExpandComponent,
        children,
        className,
        classNamePanelHeaderButtonClose,
        classNamePanelHeaderButtonExpand,
        isClosable,
        isExpandable,
        onClose,
        onExpand,
        style
    } = props

    const classNameWrapper = cx(styles['panel-header'], className, 't3sel-panel-header')
    const classNameButtonClose = cx(
        styles['panel-header-button-close'],
        classNamePanelHeaderButtonClose,
        't3sel-panel-header-button-close'
    )
    const classNameButtonExpand = cx(
        styles['panel-header-button-expand'],
        classNamePanelHeaderButtonExpand,
        't3sel-panel-header-button-expand'
    )

    const buttonClose = isClosable ? (
        <PanelHeaderButton className={classNameButtonClose} onClick={onClose}>
            {CloseComponent}
        </PanelHeaderButton>
    ) : null
    const buttonExpand = isExpandable ? (
        <PanelHeaderButton className={classNameButtonExpand} onClick={onExpand}>
            {ExpandComponent}
        </PanelHeaderButton>
    ) : null

    return (
        <header className={classNameWrapper} style={style}>
            {children}
            {buttonExpand}
            {buttonClose}
        </header>
    )
}

PanelHeader.propTypes = propTypes
PanelHeader.defaultProps = defaultProps

export default PanelHeader
